import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=89a61d32&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Product.vue?vue&type=style&index=0&id=89a61d32&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "89a61d32",
  "5b280e94"
  
)

export default component.exports